import React from 'react';
import { Outlet } from 'react-router';

const Layout = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default Layout;
